/**
 * 上下文类型：编辑器
 */
export const CONTEXT_TYPE_EDITOR = 'editor'

/**
 * 编辑器扩展键值
 */
export const editorExtKeys = [CONTEXT_TYPE_EDITOR] as const
